import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from '../auth';
import { Spinner } from '../components/Spinner';

// Profile landing surface (Brief A, IA redesign design doc §3, §7-Brief-A).
// Aggregates the durable "me" inputs — links to existing screens (Coach,
// Settings) plus placeholders for profile fields that don't have a
// dedicated edit surface yet. No new profile-editing UI here by design;
// that's future scope.
export function Profile() {
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);
  const [signOutError, setSignOutError] = useState<string | null>(null);

  const onSignOut = async (): Promise<void> => {
    setSigningOut(true);
    setSignOutError(null);
    try {
      await signOut();
      navigate('/sign-in', { replace: true });
    } catch (e) {
      // Keep the user here with a retry rather than leaving them half-signed-out.
      setSignOutError(e instanceof Error ? e.message : 'Failed to sign out');
      setSigningOut(false);
    }
  };

  return (
    <div className="shell">
      <header className="rise" style={{ marginBottom: 8 }}>
        <p className="eyebrow">You</p>
        <h1 className="h1">Profile</h1>
      </header>

      <section className="section rise">
        <div className="stack">
          <Link
            to="/coach"
            className="card card--interactive"
            style={{ display: 'block', textAlign: 'left' }}
          >
            <p className="eyebrow">Persona</p>
            <p className="h3" style={{ marginTop: 4 }}>Coach</p>
            <p className="muted" style={{ marginTop: 6, fontSize: 13 }}>
              Choose who coaches you and how they show up.
            </p>
          </Link>
          <Link
            to="/coach-notes"
            className="card card--interactive"
            style={{ display: 'block', textAlign: 'left' }}
          >
            <p className="eyebrow">Updates</p>
            <p className="h3" style={{ marginTop: 4 }}>Coach notes</p>
            <p className="muted" style={{ marginTop: 6, fontSize: 13 }}>
              Sign-off and re-engagement notices from your coach.
            </p>
          </Link>
          <Link
            to="/settings"
            className="card card--interactive"
            style={{ display: 'block', textAlign: 'left' }}
          >
            <p className="eyebrow">Account</p>
            <p className="h3" style={{ marginTop: 4 }}>Settings</p>
            <p className="muted" style={{ marginTop: 6, fontSize: 13 }}>
              Sign-in, terms, and account deletion.
            </p>
          </Link>
        </div>
      </section>

      <section className="section rise">
        <h2 className="h2">Durable inputs</h2>
        <div className="stack">
          <div className="card">
            <p className="eyebrow">Training</p>
            <p className="h3" style={{ marginTop: 4 }}>Gym access</p>
            <p className="muted" style={{ marginTop: 6, fontSize: 13 }}>Coming soon.</p>
          </div>
          <div className="card">
            <p className="eyebrow">Nutrition</p>
            <p className="h3" style={{ marginTop: 4 }}>Macro preferences</p>
            <p className="muted" style={{ marginTop: 6, fontSize: 13 }}>Coming soon.</p>
          </div>
          <div className="card">
            <p className="eyebrow">Body</p>
            <p className="h3" style={{ marginTop: 4 }}>Baseline body facts</p>
            <p className="muted" style={{ marginTop: 6, fontSize: 13 }}>Coming soon.</p>
          </div>
        </div>
      </section>

      <section className="section rise">
        {signOutError ? <div className="errorbar">{signOutError}</div> : null}
        <button
          type="button"
          className="btn btn--ghost btn--full"
          disabled={signingOut}
          onClick={() => void onSignOut()}
        >
          {signingOut ? (<><Spinner /> Signing out…</>) : 'Log out'}
        </button>
      </section>
    </div>
  );
}
